import { BrowserUtil } from './browser';
import { DateUtil } from './date';
import { DeviceUtil } from './device';
import { PlatformUtil } from './platform';
import { RestUtil } from './rest';
import { TextUtil } from './text';
import { UserUtil } from './user';
import { FileUtil } from './file';
import { KeyUtil } from './key';
import { DomUtil } from './dom';
import { DialogUtil } from './dialog';
import { ConferenceUtil } from './conference';
import { CallUtil } from './call';

export { HotkeyOs } from './key';
export const Utils = {
	browser: BrowserUtil,
	date: DateUtil,
	device: DeviceUtil,
	platform: PlatformUtil,
	rest: RestUtil,
	text: TextUtil,
	user: UserUtil,
	file: FileUtil,
	dom: DomUtil,
	key: KeyUtil,
	dialog: DialogUtil,
	conference: ConferenceUtil,
	call: CallUtil,
};
